var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppe-form',{attrs:{"entityName":"D0","title":"D0. Sous-traitants","title-field":"{operation.code}, {operation.operationname}","sub-title":"","schema":_vm.schema,"endpoint":_vm.endpoint,"redirect":'/ppe_ee/operation_home/:operationid'}})}
var staticRenderFns = []

export { render, staticRenderFns }